export type TApiDataId = number;

export type ApiData = Record<string, string | number>;

export type ChartApiData = Array<{
  label: string;
  data: Record<string, number>;
}>;
